<div class="body">
   
    <div class="logo">
        <img src="assets/optima_logo.png" style= "width:500px; height: auto; margin-bottom: 20px;">
    </div> 
    
    <div class="loginCard" *ngIf="recoverForm">
        <h5 style="margin-top: 20px;">{{ 'login.recoveryDescription' | translate }}</h5>
        <form [formGroup]="recoverForm">
            <div class="form-group">
                <label class="roboSubTitle" for="usr">{{ 'login.usr' | translate }}</label>
                <input type="text" class="form-control" id="usr" placeholder="Username" formControlName="username">
            </div>
            <div class="form-group">
                <label class="roboSubTitle" for="mail">{{ 'login.email' | translate }}</label>
                <input type="text" class="form-control" id="mail" placeholder="Email" formControlName="mail">
            </div>
        </form>
        <button type="button" class="btn btn-primary btnLogin" (click)="recovery()">{{ 'login.recoveryPsw' | translate }}</button>

        <div class="logo">
            <img src="assets/logo.png">
        </div>

        <div class="recoveryPsw" style="cursor: pointer;" (click)="router.navigate(['Login'])">
            <img src="assets/icone_varie/arrow_down_blue.png" style="transform: rotate(90deg);">
            <h5 class="roboMenu" >{{ 'login.goToLogin' | translate }}</h5>
        </div>
    </div>
    
</div>